import React from 'react'
import { useIntl } from 'react-intl'

import Text from 'Components/Text'

export default function FormFinish () {
  const intl = useIntl()
  return (<Text className='page-new-company__form-finish__text'>{intl.formatMessage({ id: 'Antes de finalizar, confira ao lado se suas informações estão corretas' })}</Text>)
}
